import React from 'react';
import { motion } from 'framer-motion';
import * as Icons from 'lucide-react';
const BoxIcon = Icons.Box;
interface KpiCardProps {
  label: string;
  value: string | number;
  iconName: keyof typeof Icons;
  color: string;
  clickable?: boolean;
  onClick?: () => void;
  footnote?: React.ReactNode;
}
const colorMap: Record<string, {
  bg: string;
  icon: string;
}> = {
  blue: {
    bg: 'bg-blue-50',
    icon: 'text-blue-600'
  },
  purple: {
    bg: 'bg-purple-50',
    icon: 'text-purple-600'
  },
  green: {
    bg: 'bg-green-50',
    icon: 'text-green-600'
  },
  amber: {
    bg: 'bg-amber-50',
    icon: 'text-amber-600'
  }
};
export function KpiCard({
  label,
  value,
  iconName,
  color,
  clickable = false,
  onClick,
  footnote
}: KpiCardProps) {
  const Icon = Icons[iconName] as BoxIcon;
  const colors = colorMap[color] || colorMap.blue;
  const content = <>
      <div className="flex items-center gap-3 mb-2" data-id="element-172">
        <div className={`${colors.bg} p-2 rounded-full`} data-id="element-173">
          <Icon className={`w-5 h-5 ${colors.icon}`} data-id="element-174" />
        </div>
        <div className="text-xs font-bold uppercase tracking-wide text-slate-500" data-id="element-175">
          {label}
        </div>
      </div>
      <div className="flex items-center justify-between" data-id="element-176">
        <div className="text-3xl font-bold text-slate-900" data-id="element-177">{value}</div>
        {clickable && <Icons.ArrowUpRight className="w-5 h-5 text-slate-400" data-id="element-178" />}
      </div>
      {footnote && <div className="mt-2 text-xs text-slate-500" data-id="element-179">{footnote}</div>}
    </>;
  if (clickable) {
    return <motion.button whileHover={{
      y: -2
    }} transition={{
      duration: 0.15
    }} onClick={onClick} className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm hover:shadow-md transition-shadow text-left w-full" data-id="element-180">
        {content}
      </motion.button>;
  }
  return <div className="bg-white rounded-xl border border-slate-200 p-6 shadow-sm w-full" data-id="element-181">
      {content}
    </div>;
}